"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/PatientTable/Table.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _phone = require('shared/services/phone');

var _Avatar = require('web/components/Avatar');
var _Tooltip = require('web/components/Tooltip');
var _Checkbox = require('web/screens/Broadcast/CampaignPage/Body/MessagesTable/components/Checkbox'); var _Checkbox2 = _interopRequireDefault(_Checkbox);
var _MenuItem = require('web/screens/Broadcast/MenuItem'); var _MenuItem2 = _interopRequireDefault(_MenuItem);
var _useMenuButton = require('web/screens/Broadcast/useMenuButton'); var _useMenuButton2 = _interopRequireDefault(_useMenuButton);




var _format = require('./format');














const TAG_GAP = 4 // .dir-tags gap

// How many tags fit on one line of `room`: as many as fit whole, then "+N" for
// the rest (D-95). The first tag always shows, cut short if it must be.
 const fitTags = (widths, moreWidth, room) => {
  let used = 0
  for (let i = 0; i < widths.length; i++) {
    used += (i ? TAG_GAP : 0) + widths[i]
    const more = i < widths.length - 1 ? TAG_GAP + moreWidth : 0
    if (used + more > room) return Math.max(i, 1)
  }
  return widths.length
}; exports.fitTags = fitTags

// Every tag renders; those past the line stay measurable but out of the flow,
// so the count follows the column's width as it changes.
 const PatientTags = ({ tags }) => {
  const ref = _react.useRef(null)
  const [shown, setShown] = _react.useState.call(void 0, tags.length)
  const measure = _react.useCallback.call(void 0, () => {
    const el = ref.current
    // A cell with no width isn't laid out (hidden, or a test): nothing to fit.
    if (!_optionalChain([el, 'optionalAccess', _ => _.clientWidth])) return
    const chips = [...el.querySelectorAll(':scope > .blm-name--badge')]
    const more = el.querySelector('.dir-tags--more')
    setShown(exports.fitTags.call(void 0, chips.map(c => c.offsetWidth), _nullishCoalesce(_optionalChain([more, 'optionalAccess', _2 => _2.offsetWidth]), () => ( 0)), el.clientWidth))
  }, [])
  _react.useLayoutEffect.call(void 0, measure, [measure, tags])
  _react.useEffect.call(void 0, () => {
    const el = ref.current
    if (!el || typeof ResizeObserver === 'undefined') return
    // The chips too: a web font arriving widens them, not the cell.
    const observer = new ResizeObserver(measure)
    observer.observe(el)
    el.querySelectorAll(':scope > .blm-name--badge').forEach(chip => observer.observe(chip))
    return () => observer.disconnect()
  }, [measure, tags])

  if (!tags.length) return _react2.default.createElement('span', { className: "dir-cell--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}, "—")
  const hidden = tags.slice(shown)
  return (
    _react2.default.createElement('div', { className: "dir-tags dir-tags--fit" , ref: ref, __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
      ,  tags.map((tag, i) => (
        _react2.default.createElement('span', { key: tag.TagKey, className: _classBuilder2.default.call(void 0, 'blm-name--badge', i >= shown && 'dir-tags--over'), 'aria-hidden': i >= shown || undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}
          ,  tag.Name 
        )
      ))
      ,  tags.length > 1 && (
        _react2.default.createElement(_Tooltip.HoverTooltip, {
          type: "dark",
          place: "top",
          showOnFocus: true,
          mobileShow: true,
          className: _classBuilder2.default.call(void 0, 'dir-tags--more-wrap', !hidden.length && 'dir-tags--over'),
          content: _react2.default.createElement(_Tooltip.TooltipHint, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 86}},  hidden.map(t => t.Name).join(', ') ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}

          , _react2.default.createElement('button', {
            type: "button",
            className: "list-item--team dir-tags--more" ,
            tabIndex: hidden.length ? 0 : -1,
            'aria-hidden': !hidden.length || undefined,
            'aria-label': `${hidden.length} more ${hidden.length === 1 ? 'tag' : 'tags'}: ${hidden.map(t => t.Name).join(', ')}`,
            onClick: e => e.stopPropagation(), __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}
, "+"
            ,  Math.max(hidden.length, 1) 
          )
        )
      )
    )
  )
}; exports.PatientTags = PatientTags

const statusPill = (label, pill) => (
  _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'campaign--table--status-pill', pill), __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}
    , _react2.default.createElement('span', { className: "campaign--table--status-pill--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}},  label )
  )
)

const muted = (text) => text === '—' ? _react2.default.createElement('span', { className: "dir-cell--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}, "—") : text

const dob = { id: 'dob', label: 'Date of birth', sort: 'date_of_birth', cell: r => muted(_format.formatDOB.call(void 0, r.DateOfBirth) || '—') }
const phone = { id: 'phone', label: 'Phone', sort: 'phone', cell: r => muted(_phone.formatPhoneNumber.call(void 0, r.Phone) || '—') }
const tags = { id: 'tags', label: 'Tags', cell: r => _react2.default.createElement(exports.PatientTags, { tags: r.Tags, __self: this, __source: {fileName: _jsxFileName, lineNumber: 114}} ) }
const lastFrom = { id: 'lastFrom', label: 'Last from patient', sort: 'last_from_patient', cell: r => muted(_format.formatActivity.call(void 0, r.LastFromPatientAt)) }

// The approved frames' columns and widths for each view (patients-v3-default,
// patients-v3-archived); the last column takes the rest.
 const COLUMNS = {
  active: [
    { ...dob, width: 108 },
    { ...phone, width: 130 },
    { id: 'email', label: 'Email', sort: 'email', width: 198, cell: r => muted(r.Email || '—') },
    { ...tags, width: 162 },
    { id: 'created', label: 'Created', sort: 'created', width: 106, cell: r => _format.formatDay.call(void 0, r.CreatedAt) },
    { ...lastFrom, width: 140 },
    { id: 'lastTo', label: 'Last to patient', sort: 'last_to_patient', width: 136, cell: r => muted(_format.formatActivity.call(void 0, r.LastToPatientAt)) },
    {
      id: 'texting',
      label: 'Texting',
      sort: 'texting',
      className: 'campaign--table--row-status',
      cell: r => statusPill(_format.TEXTING_LABELS[r.Texting], _format.TEXTING_PILLS[r.Texting]),
    },
  ],
  archived: [
    { ...dob, width: 112 },
    { ...phone, width: 136 },
    { ...tags, width: 190 },
    { id: 'archivedAt', label: 'Archived', sort: 'archived_at', width: 120, cell: r => _format.formatDay.call(void 0, r.ArchivedAt) },
    { id: 'archivedBy', label: 'Archived by', sort: 'archived_by', width: 150, cell: r => r.ArchivedByName || '' },
    { ...lastFrom, width: 160 },
    {
      id: 'status',
      label: 'Status',
      className: 'campaign--table--row-status',
      cell: () => statusPill('Archived', 'campaign--table--status-pill-not-scheduled'),
    },
  ],
}; exports.COLUMNS = COLUMNS

 const NAME_WIDTH = { active: 184, archived: 200 }; exports.NAME_WIDTH = NAME_WIDTH











































/* The header checkbox and the caret that opens its menu (direction C,
 * c-pt2menu): the page, everyone matching, or nothing. */
const HeaderSelect




 = ({ allSelection, isDisabled, onSelectAll, menu }) => {
  const button = _useMenuButton2.default.call(void 0, { isDisabled: isDisabled || menu.isDisabled })
  // Escape closes this menu on keydown; its keyup must not then close a
  // dialog around the table, which closes on keyup (rev 4 QA F-1).
  const isClosingByEscape = _react.useRef.call(void 0, false)
  const choose = (run) => () => {
    button.close()
    run()
  }
  return (
    // oxlint-disable-next-line jsx-a11y/no-static-element-interactions -- only swallows the keyup of the menu's own Escape
    _react2.default.createElement('div', {
      ref: button.rootRef,
      className: "dir-head-select",
      onKeyUp: e => {
        if (e.key === 'Escape' && isClosingByEscape.current) {
          isClosingByEscape.current = false
          e.stopPropagation()
        }
      }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 214}}

      , _react2.default.createElement(_Checkbox2.default, {
        isChecked: allSelection.isChecked,
        isMixed: allSelection.isMixed,
        isDisabled: isDisabled || menu.isDisabled,
        onChange: onSelectAll,
        label: "Select this page"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 224}}
      )
      , _react2.default.createElement('button', {
        ...button.triggerProps,
        type: "button",
        className: "dir-head-select--caret",
        'aria-label': "Selection options" ,
        disabled: isDisabled || menu.isDisabled, __self: this, __source: {fileName: _jsxFileName, lineNumber: 231}}

        , _react2.default.createElement('span', { 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 238}}, "▾")
      )
      ,  button.isOpen && (
        _react2.default.createElement('div', {
          ...button.menuProps,
          'aria-label': "Select",
          className: "broadcast-menu dir-head-select--menu" ,
          onKeyDown: e => {
            if (e.key === 'Escape') {
              isClosingByEscape.current = true
              e.stopPropagation()
            }
            button.menuProps.onKeyDown(e)
          }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 241}}

          , _react2.default.createElement(_MenuItem2.default, { label: "This page" , desc: `${_format.formatCount.call(void 0, menu.pageCount)} ${menu.pageCount === 1 ? 'patient' : 'patients'}`, onClick: choose(menu.onPage), __self: this, __source: {fileName: _jsxFileName, lineNumber: 253}} )
          , _react2.default.createElement(_MenuItem2.default, { label: `All ${_format.formatCount.call(void 0, menu.matchingCount)} matching`, desc: `Up to ${_format.formatCount.call(void 0, _format.MAX_PER_ACTION)} per action`, onClick: choose(menu.onAll), __self: this, __source: {fileName: _jsxFileName, lineNumber: 254}} )
          , _react2.default.createElement(_MenuItem2.default, { label: "Clear selection" , onClick: choose(menu.onClear), __self: this, __source: {fileName: _jsxFileName, lineNumber: 255}} )
        )
      )
    )
  )
}

const PENDING_LABELS = { archive: 'Archiving…', restore: 'Restoring…' }
const PENDING_TITLES = { archive: 'Being archived', restore: 'Being restored' }
const STATE_COLUMNS = new Set(['texting', 'status'])

const SortHeader = ({ column, sort, onSort }) => {
  if (!column.sort) return _react2.default.createElement(_react2.default.Fragment, null,  column.label )
  const isActive = sort.sort === column.sort
  return (
    _react2.default.createElement('span', {
      role: "button",
      tabIndex: 0,
      className: _classBuilder2.default.call(void 0, 'dir-sort', isActive && 'dir-sort--active', isActive && !sort.desc && 'dir-sort--asc'),
      onClick: () => onSort(column.sort),
      onKeyDown: e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onSort(column.sort)
        }
      }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 270}}

      ,  column.label 
    )
  )
}

const ariaSort = (column, sort) => column.sort && sort.sort === column.sort
  ? (sort.desc ? 'descending' : 'ascending')
  : undefined

const PatientTable = ({
  view, hiddenColumns, rows, sort, onSort, isSelected, onToggle, allSelection, onSelectAll, selectMenu,
  openPatientKey = null, onOpen, emptyState, emptyClassName, isBusy, pending, added, markedNew = null, label,
}) => {
  // Whether the press that ticks a checkbox held Shift; the input's change
  // event doesn't say.
  const isShift = _react.useRef.call(void 0, false)
  const columns = exports.COLUMNS[view].filter(c => !hiddenColumns.has(c.id))
  const nameColumn = { id: 'name', label: 'Patient', sort: 'name', cell: () => null }
  return (
    _react2.default.createElement('div', { className: "campaign--table--wrapper campaign--table--wrapper--scroll" , 'aria-busy': isBusy || undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 301}}
      , _react2.default.createElement('table', { className: "campaign--table", 'aria-label': label, __self: this, __source: {fileName: _jsxFileName, lineNumber: 302}}
        , _react2.default.createElement('colgroup', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 303}}
          , _react2.default.createElement('col', { style: { width: selectMenu ? 58 : 42 }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 304}} )
          , _react2.default.createElement('col', { style: { width: exports.NAME_WIDTH[view] }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 305}} )
          ,  columns.map((c, i) => (
            _react2.default.createElement('col', { key: c.id, style: i < columns.length - 1 && c.width ? { width: c.width } : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 307}} )
          ))
        )
        , _react2.default.createElement('thead', { className: "campaign--table--head campaign--table--head--sticky" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 310}}
          , _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 311}}
            , _react2.default.createElement('th', { className: "campaign--table--row-checkbox", 'aria-label': "Toggle selection" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 312}}
              ,  selectMenu
                ? _react2.default.createElement(HeaderSelect, { allSelection: allSelection, isDisabled: rows.length === 0, onSelectAll: onSelectAll, menu: selectMenu, __self: this, __source: {fileName: _jsxFileName, lineNumber: 314}} )
                : (
                    _react2.default.createElement(_Checkbox2.default, {
                      isChecked: allSelection.isChecked,
                      isMixed: allSelection.isMixed,
                      isDisabled: rows.length === 0,
                      onChange: onSelectAll,
                      label: "Select all matching patients"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 316}}
                    )
                  )
            )
            , _react2.default.createElement('th', { className: "campaign--table--col-name", 'aria-sort': ariaSort(nameColumn, sort), __self: this, __source: {fileName: _jsxFileName, lineNumber: 325}}
              , _react2.default.createElement(SortHeader, { column: nameColumn, sort: sort, onSort: onSort, __self: this, __source: {fileName: _jsxFileName, lineNumber: 326}} )
            )
            ,  columns.map(c => (
              _react2.default.createElement('th', { key: c.id, 'aria-sort': ariaSort(c, sort), __self: this, __source: {fileName: _jsxFileName, lineNumber: 329}}
                , _react2.default.createElement(SortHeader, { column: c, sort: sort, onSort: onSort, __self: this, __source: {fileName: _jsxFileName, lineNumber: 330}} )
              )
            ))
          )
        )
        , _react2.default.createElement('tbody', { className: "campaign--table--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 335}}
          ,  rows.map(row => {
            const isAdded = !!_optionalChain([added, 'optionalAccess', _3 => _3.has, 'call', _4 => _4(row.PatientKey)])
            const selected = isAdded || isSelected(row.PatientKey)
            const pendingKind = pending.get(row.PatientKey)
            const isLocked = !!pendingKind || isAdded
            return (
              _react2.default.createElement('tr', {
                key: row.PatientKey,
                className: _classBuilder2.default.call(void 0, 
                  'campaign--table--row',
                  isAdded ? 'campaign--table--row--added' : selected && 'campaign--table--row--selected',
                  openPatientKey === row.PatientKey && 'campaign--table--row--open',
                  pendingKind && 'campaign--table--row--pending',
                ),
                ...(onOpen
                  ? {
                      "tabIndex": 0,
                      'aria-label': `Open ${row.Name}`,
                      "onClick": () => onOpen(row),
                      "onKeyDown": (e) => {
                        if (e.target === e.currentTarget && (e.key === 'Enter' || e.key === ' ')) {
                          e.preventDefault()
                          onOpen(row)
                        }
                      },
                    }
                  : {
                      // The checkbox is the keyboard control.
                      onMouseDown: (e) => {
                        isShift.current = e.shiftKey
                        if (e.shiftKey) e.preventDefault()
                      },
                      onClick: (e) => { if (!isLocked) onToggle(row.PatientKey, e.shiftKey) },
                    }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 342}}

                /* A click anywhere in the checkbox cell ticks the row; it never opens the panel. */
                /* oxlint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions -- the checkbox inside is the keyboard control */
                , _react2.default.createElement('td', {
                  className: "campaign--table--row-checkbox",
                  title: pendingKind ? PENDING_TITLES[pendingKind] : isAdded ? 'Already added' : undefined,
                  onMouseDown: e => {
                    isShift.current = e.shiftKey
                    // A shift-click selects rows, not the text between them.
                    if (e.shiftKey) e.preventDefault()
                  },
                  onClick: e => {
                    e.stopPropagation()
                    if (!isLocked) onToggle(row.PatientKey, e.shiftKey)
                  }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 373}}

                  , _react2.default.createElement(_Checkbox2.default, {
                    isChecked: selected,
                    isDisabled: isLocked,
                    onChange: () => {
                      onToggle(row.PatientKey, isShift.current)
                      isShift.current = false
                    },
                    label: pendingKind
                      ? `${row.Name}: ${PENDING_TITLES[pendingKind].toLowerCase()}`
                      : isAdded ? `${row.Name}: already added` : `Select ${row.Name}`,
                    className: "campaign--table--record-checkbox", __self: this, __source: {fileName: _jsxFileName, lineNumber: 386}}
                  )
                )
                , _react2.default.createElement('td', { className: "campaign--table--col-name", title: row.Name, __self: this, __source: {fileName: _jsxFileName, lineNumber: 399}}
                  , _react2.default.createElement('div', { className: "campaign--table--col-name--inner", __self: this, __source: {fileName: _jsxFileName, lineNumber: 400}}
                    , _react2.default.createElement(_Avatar.PatientAvatar, { size: 22, noBadge: true, patientKey: row.PatientKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 401}} )
                    , _react2.default.createElement('span', { className: "campaign--table--col-name--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 402}},  row.Name )
                    ,  markedNew === row.PatientKey && _react2.default.createElement('span', { className: "dir-new-badge", __self: this, __source: {fileName: _jsxFileName, lineNumber: 403}}, "New") 
                  )
                )
                ,  columns.map(c => (
                  _react2.default.createElement('td', { key: c.id, className: c.className, __self: this, __source: {fileName: _jsxFileName, lineNumber: 407}}
                    ,  pendingKind && STATE_COLUMNS.has(c.id)
                      ? statusPill(PENDING_LABELS[pendingKind], 'campaign--table--status-pill-processing')
                      : isAdded && STATE_COLUMNS.has(c.id)
                        ? _react2.default.createElement('span', { className: "campaign--table--added", __self: this, __source: {fileName: _jsxFileName, lineNumber: 411}}, "Already added" )
                        : c.cell(row) 
                  )
                ))
              )
            )
          })
        )
      )
      ,  rows.length === 0 && emptyState && (
        _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'campaign--table--empty', emptyClassName), __self: this, __source: {fileName: _jsxFileName, lineNumber: 421}},  emptyState )
      )
    )
  )
}

exports. default = PatientTable
